let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45p4J")).then(() => parcelRequire('j9QH7'));